import React from 'react';
import {
    DiscoverEventCardProps,
    EXPERIMENT_SEARCH_CARD_MAP_DESKTOP,
    EXPERIMENT_SEARCH_CARD_MAP_MOBILE,
} from '../../components/DiscoverEventCard';
import { useGetExperimentMobileSearchCardType } from '../../context/SearchServerEnrolledExperiment';
import {
    SearchCardDesktopExperimentValues,
    SearchCardMobileExperimentValues,
} from '../../types/Experiments';
import './SearchEventCardStyleSwitcher.scss';

function useGetEventCardTypes() {
    const variantType = useGetExperimentMobileSearchCardType();

    const MobileEventCard = variantType
        ? EXPERIMENT_SEARCH_CARD_MAP_MOBILE[variantType]
        : EXPERIMENT_SEARCH_CARD_MAP_MOBILE[
              SearchCardMobileExperimentValues.control
          ];

    const DesktopEventCard =
        EXPERIMENT_SEARCH_CARD_MAP_DESKTOP[
            SearchCardDesktopExperimentValues.control
        ];

    return {
        MobileEventCard: MobileEventCard,
        DesktopEventCard: DesktopEventCard,
    };
}

export const SearchEventCardStyleSwitcher: React.FunctionComponent<
    DiscoverEventCardProps
> = (props) => {
    const { MobileEventCard, DesktopEventCard } = useGetEventCardTypes();

    return (
        <>
            <div
                className="discover-search-mobile-card"
                key={`discover-mobile-event-card-${props.event.id}`}
            >
                <MobileEventCard {...props} />
            </div>
            <div
                className="discover-search-desktop-card"
                key={`discover-desktop-event-card-${props.event.id}`}
            >
                <DesktopEventCard {...props} />
            </div>
        </>
    );
};
